<template>
  <div class="modal fade" :id="modalId" tabindex="-1"
       role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body d-flex flex-column justify-content-center modal-alert">
          <div class="text-center">
            <app-icon class="text-success" :name="'check-circle'"/>
          </div>
          <h5 class="text-center font-weight-bold mt-4">{{ $t('congratulation') }}</h5>
          <p class="mb-primary text-center font-size-90 p-0">{{$t('you_won_the_deal_successfully')}}</p>
          <div class="text-center">
            <a href="#" class="btn btn-success" @click.prevent="confirmDealWon">
                {{$t('thank_you')}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {FormMixin} from "@core/mixins/form/FormMixin";
import {api} from "@app/Helpers/api";
import {collect} from "@app/Helpers/Collection";

export default {
  name: "DealWonConfirmModal",
  props:{
    modalId: {
      type: String,
      required: true
    },
    dealWonData:{
      type:Object,
      required:true,
    }
  },
  mixins:[FormMixin],
  data(){
    return{
      formData:{},
      api,
      collect
    }
  },
  methods:{
    closed(){
      this.$emit('won-close-modal', false);
    },
    confirmDealWon(){
      this.formData.title = this.dealWonData.title;
      this.formData.pipeline_id = this.dealWonData.pipeline_id;
      this.formData.stage_id = this.dealWonData.stage_id;

      api
        .route("crm/statuses")
        .params({ name: "status_won", type: "deal" })
        .get()
        .then((res) => {
          this.formData.status_id = collect(res).first().id;
          this.axiosPatch({
            url: `crm/deals/${this.dealWonData.id}`,
            data: this.formData,
          }).then((response) => {
            this.$hub.$emit("tag-list");
            this.$toastr.s(response.data.message);
            this.closed();
          });
        });
    }
  },
  mounted() {
    $('#' + this.modalId).on('hidden.bs.modal', (e) => {
      this.closed();
    });

    $('#' + this.modalId).modal('show');
  },
}
</script>
